$(document).ready(function () {
  setTimeout(function(){
    var valueOption = jQuery('[name="purchaseOption"]:checked').val();
    subscirbeHtml(valueOption);
  },1000);
});

jQuery(document).on("change","[name='purchaseOption']",function(){
  var valueOption = jQuery(this).val();
  subscirbeHtml(valueOption);
});

function subscirbeHtml(val){
  if(val=='subscription'){
      if($('.recharge-subscription-widget').length !== 0){
        jQuery('.subsave-usps').remove();
        jQuery(".recharge-subscription-widget .rc-selling-plans").append('<ul class="subsave-usps"> <li><b>FREE shipping</b> on all orders</li> <li><b>Save 10% extra</b> of your first purchase</li> <li><b>Quick & easy cancel</b>, no questions asked</li> </ul>');
      }
  }
}